"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.getSaleReward = getSaleReward;
exports.groupByBookings = groupByBookings;
exports.groupByBookingsByOrderFactory = groupByBookingsByOrderFactory;
var _groupBy2 = _interopRequireDefault(require("lodash/groupBy"));
var _saleFactory = require("../factories/sale-factory");
var _order = require("../factories/order.factory");
function groupByBookings(data, env) {
  const factories = data && data.map(booking => (0, _saleFactory.saleFactory)(booking, env));
  return (0, _groupBy2.default)(factories, item => {
    var _item$additionalData, _item$additionalData$;
    return ((_item$additionalData = item.additionalData) === null || _item$additionalData === void 0 ? void 0 : (_item$additionalData$ = _item$additionalData.relatedToOrder) === null || _item$additionalData$ === void 0 ? void 0 : _item$additionalData$.orderId) || item._id;
  });
}
function groupByBookingsByOrderFactory(data, env, sale) {
  const factories = data && data.map((booking, index) => {
    var _booking$additionalDa, _booking$additionalDa2;
    if ((_booking$additionalDa = booking.additionalData) !== null && _booking$additionalDa !== void 0 && (_booking$additionalDa2 = _booking$additionalDa.relatedToOrder) !== null && _booking$additionalDa2 !== void 0 && _booking$additionalDa2.orderId) {
      return {
        saleDetails: sale,
        ...(0, _saleFactory.saleFactory)(booking, env)
      };
    }
    return {
      saleDetails: sale,
      ...booking,
      ...(0, _order.orderFactory)(booking, env.currency.formatPrice, env.config.language)
    };
  });
  return (0, _groupBy2.default)(factories, item => {
    var _item$additionalData2, _item$additionalData3;
    return ((_item$additionalData2 = item.additionalData) === null || _item$additionalData2 === void 0 ? void 0 : (_item$additionalData3 = _item$additionalData2.relatedToOrder) === null || _item$additionalData3 === void 0 ? void 0 : _item$additionalData3.orderId) || item._id;
  });
}

/**
 * @typedef {Object} Reward
 * @property {number} value
 * @property {number} points
 * @property {Date} expiryDate
 * @property {string} method
 * @property {string} identifier
 *
 * reward
 * @param {Object} sale
 * @return {Reward}
 */
function getSaleReward(sale) {
  var _sale$data, _sale$data$loyalty, _sale$data2;
  const result = {};
  if (!((_sale$data = sale.data) !== null && _sale$data !== void 0 && (_sale$data$loyalty = _sale$data.loyalty) !== null && _sale$data$loyalty !== void 0 && _sale$data$loyalty.hasReward)) return {};
  const {
    reward,
    hasReward
  } = ((_sale$data2 = sale.data) === null || _sale$data2 === void 0 ? void 0 : _sale$data2.loyalty) || {};
  result.hasReward = hasReward;
  Object.keys(reward).map(method => {
    var _details$ordersIds$;
    const {
      details,
      totalValue,
      totalPoints
    } = reward[method];
    result.method = method;
    result.value = totalValue;
    result.points = totalPoints;
    const ordersIds = Object.keys(details);
    const {
      identifier,
      rewardExpiryDate
    } = ((_details$ordersIds$ = details[ordersIds[0]]) === null || _details$ordersIds$ === void 0 ? void 0 : _details$ordersIds$.reward) || {};
    result.identifier = identifier;
    result.expiryDate = rewardExpiryDate;
  });
  return result;
}